/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N1Inputs */

const en_to_csv_ref_n1 = /** @type {(inputs: To_Csv_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No special characters, so no quoting is added.`)
};

const ko_to_csv_ref_n1 = /** @type {(inputs: To_Csv_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`특수 문자가 없으므로 인용이 추가되지 않습니다.`)
};

const ja_to_csv_ref_n1 = /** @type {(inputs: To_Csv_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特殊文字がないので引用は追加されません。`)
};

/**
* | output |
* | --- |
* | "No special characters, so no quoting is added." |
*
* @param {To_Csv_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n1 = /** @type {((inputs?: To_Csv_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n1(inputs)
	if (locale === "ko") return ko_to_csv_ref_n1(inputs)
	return ja_to_csv_ref_n1(inputs)
});